@let support = support$ | async;
@let comments = comments$ | async;
@let isClosed = isClosed$ | async;

<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Ajuda'"
    [titleIcon]="'pi pi-comments'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Ajuda', link: '/support', icon: 'pi pi-comments' },
      { label: 'Detalhes', icon: 'pi pi-eye' },
    ]"></app-page-header>

  <div class="support-detail container-fluid">
    @if (support) {
      <div class="support-detail__layout">
        <aside class="support-detail__sidebar">
          <button type="button" class="support-detail__back-button" (click)="goBack()">
            <i class="pi pi-chevron-left"></i>
          </button>

          <app-support-info-card [support]="support" />
        </aside>

        <main class="support-detail__main">
          <app-task-comments
            [comments]="comments ?? []"
            [closed]="isClosed ?? false"
            [closedAt]="support.updated_at"
            [closedMessage]="'Chamado encerrado em:'"
            [closedBadge]="'Chamado Encerrado'"
            [submitting]="isSubmittingComment()"
            (commentSubmit)="handleCommentSubmit($event)">
            <section class="support-detail__summary-section">
              <h3 class="support-detail__section-title">DETALHES DO CHAMADO</h3>
              <div class="support-detail__summary">
                <h4 class="support-detail__summary-title">{{ support.title }}</h4>
                <p class="support-detail__summary-description">{{ support.description }}</p>
              </div>
            </section>
          </app-task-comments>
        </main>
      </div>
    } @else {
      <div class="support-detail__layout">
        <aside class="support-detail__sidebar">
          <p-skeleton shape="circle" width="36px" height="36px" />
          <p-skeleton height="180px" borderRadius="8px" />
        </aside>
        <main class="support-detail__main support-detail__main--skeleton">
          <p-skeleton width="200px" height="24px" />
          <p-skeleton height="100%" borderRadius="8px" />
          <p-skeleton height="80px" borderRadius="8px" />
        </main>
      </div>
    }
  </div>
</app-layout>
